export const translations = {
  email: {
    placeholder: {
      en: "Your email address",
      zh: "您的电子邮件地址",
      ja: "あなたのメールアドレス",
      ko: "귀하의 이메일 주소"
    },
    error: {
      en: "Enter a valid email address",
      zh: "请输入有效的电子邮件地址",
      ja: "有効なメールアドレスを入力してください",
      ko: "유효한 이메일 주소를 입력하세요"
    }
  }
} as const;